import actions from "./actions";

const initState = { contractors: [], accounts: [], subcRates: [] };

export default function contractorReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_ALL_CONTRACTORS:
      return {
        ...state,
        contractors: action.payload,
      };
    case actions.SET_ALL_CONTRACTOR_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      };
    case actions.SET_SUBCONTRACTOR_RATE:
      return {
        ...state,
        subcRates: action.payload,
      };
    default:
      return state;
  }
}
